var churchBannerSwiper = new Swiper('.church-banner-swiper', {
	spaceBetween: 0,
	effect: 'fade',
	speed: 1000,
	autoplay: {
		delay: 3000,
	},
	fadeEffect: {
		crossFade: false,
	},
});

$('[data-accordion]').accordion();

$.each([
    $(".church-intro .intro-text h2.section-title"),
    $(".church-intro .intro-text h4.section-title").eq(0),
    $(".church-intro .intro-text .cms-content").eq(0),
    $(".church-intro .intro-text h4.section-title").eq(1),
    $(".church-intro .intro-text .cms-content").eq(1),
], function(i, v){
    $(this).attr({
        'data-aos': "gentle-up",
        'data-aos-anchor': ".intro-text",
        'data-aos-anchor-placement': "top-bottom",
        'data-aos-duration': 1500,
        'data-aos-delay': 600 + i*300,
    });
})

var subPageSwiper = new Swiper('.page-section-swiper', {
	spaceBetween: 0,
	slidesPerView: 1,
	speed: 600,
	autoHeight: 'auto',
	allowTouchMove: false,
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
});

$("[data-scroll-to]").click(function(e){
	e.preventDefault();
	if($(this).parent().hasClass("active")){
		return false;
	}
	$.scrollTo($("#church-detail-anchor"));
	subPageSwiper.slideTo($(this).data("scroll-to"));
	$(this).parent().addClass("active").siblings().removeClass("active");
	
})

var scrollElem = $(".church-submenu .overflow-container");
scrollElem.on('scroll', function(){
	if((scrollElem.scrollLeft() + scrollElem.width() + 4) >= Math.floor($("ul", scrollElem).width())){
		$("[data-scroll-right]").fadeOut();
	}else{
		$("[data-scroll-right]").fadeIn();
	}
	if(scrollElem.scrollLeft() == 0){
		$("[data-scroll-left]").fadeOut();
	}else{
		$("[data-scroll-left]").fadeIn();
	}
}).trigger("scroll");

$("[data-scroll-left]").click(function(e){
	e.preventDefault();
	scrollElem.scrollTo("-=250px", {axis:"x"});
})
$("[data-scroll-right]").click(function(e){
	e.preventDefault();
	scrollElem.scrollTo("+=250px", {axis:"x"});
})

$(window).resize(function(){
	$("main").css('padding-top', $(".church-slider").outerHeight());
	if(scrollElem.outerWidth() >= scrollElem.children("ul")){
		$("[data-scroll-left], [data-scroll-right]").fadeOut()
	}else{
		scrollElem.trigger("scroll");
	}
}).trigger('resize');



var tl = gsap.timeline();
tl.from(".church-slider h5, .church-slider h3", {
  duration:1,
  delay:1.5,
  opacity:0,
  y:30,
  stagger:.4
});
tl.pause();

$(window).on('load', function(){
  tl.play();
})

var controller = new ScrollMagic.Controller();

var scene = new ScrollMagic.Scene({
	triggerElement: "main",
	triggerHook: 0,
	duration: "100%",
})
.setTween(".church-slider", 1, {y: "-50%"})
.addTo(controller);
